var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#FFE100",
    fillOpacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2026_1177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9998 39.1429C34.1538 39.1429 39.1426 34.1541 39.1426 28C39.1426 21.846 34.1538 16.8572 27.9998 16.8572C21.8458 16.8572 16.8569 21.846 16.8569 28C16.8569 34.1541 21.8458 39.1429 27.9998 39.1429Z",
    stroke: "#FFE100",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 22V27.1429",
    stroke: "#FFE100",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9997 33.1429C28.4731 33.1429 28.8569 32.7591 28.8569 32.2857C28.8569 31.8123 28.4731 31.4286 27.9997 31.4286C27.5263 31.4286 27.1426 31.8123 27.1426 32.2857C27.1426 32.7591 27.5263 33.1429 27.9997 33.1429Z",
    stroke: "#FFE100",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2026_1177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleEntry);
export default __webpack_public_path__ + "static/media/multipleEntry.5e9b7444a275920599fc57285ece322d.svg";
export { ForwardRef as ReactComponent };